module.exports = __webpack_public_path__ + "img/main-bg.965338e4.webp";